import {List} from 'immutable';

export const getImageUrl = (
    image,
    constrainedWidth,
    constrainedHeight,
    options = {pointPixelRatio: 1, forceDimensions: false},
) => {
    const {pointPixelRatio, forceDimensions} = options;

    if (!image) {
        throw Error('Image must be provided');
    }

    if (!constrainedWidth || !constrainedHeight) {
        throw Error(
            `The constrained height and width of image ${image.id} must be a positive number - got: ${constrainedWidth} x ${constrainedHeight}`,
        );
    }

    if (pointPixelRatio < 1) {
        throw Error('pointPixelRatio must be a positive number');
    }

    const {width, height} = forceDimensions
        ? {width: constrainedWidth, height: constrainedHeight}
        : getBucketedSize(
              Math.floor(constrainedWidth * pointPixelRatio),
              Math.floor(constrainedHeight * pointPixelRatio),
          );

    // Images in graphQL have a secret with the info to build the url
    if (image.secret) {
        return `${image.secret.prefix}/${image.secret.key}/${width}x${height}/${image.secret.path}?expires=${image.secret.expires}`;
    }

    // Images from PHP have that information condensed in the prefix and key variables
    if (image.prefix && image.key && image.expires) {
        return `${image.prefix}/${width}x${height}/${image.key}?expires=${image.expires}`;
    }

    // Images from PHP have that information condensed in the prefix and key variables
    if (image.prefix && image.key) {
        return `${image.prefix}/${width}x${height}/${image.key}`;
    }

    // Fallback
    return image.thumbnail ? image.thumbnail.url : image.url;
};

// To make sure we can properly cache image requests across all device types we ask the backend to serve one of three sizes of images
const portraitBuckets = List([
    {width: 520, height: 1040}, // Feed width
    {width: 1080, height: 1920},
]);
const landscapeBuckets = portraitBuckets.map(b => ({width: b.height, height: b.width}));

const getBucketedSize = (desiredWidth, desiredHeight) => {
    const buckets = desiredHeight > desiredWidth ? portraitBuckets : landscapeBuckets;
    const matchingSize = buckets.find(b => desiredWidth <= b.width && desiredHeight <= b.height);

    // If the photo is larger than our largest size, return the largest size
    return matchingSize || buckets.last();
};
